<template>
  <div :class="'grammar-theme-' + theme">
    <div v-if="entity.title">{{entity.title}}</div>
    <img :src="imageUrl" v-if="entity.image"/>
    <pinyin :text="entity.text" :pinyin="entity.pinyin"></pinyin>
    <div v-if="entity.explain">{{entity.explain}}</div>
  </div>
</template>

<script>
import utils from './../../js/utils'
import pinyin from './../PinyinPreview'

export default {
  name: 'GrammarPreview',
  components: { pinyin },
  props: {
    entity: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {
      type: String,
      default: 'card'
    }
  },
  data () {
    return {}
  },
  computed: {
    imageUrl () {
      return this.entity.image ? utils.url(this.entity.image) : ''
    }
  }
}
</script>
